import type { AreaSubstrate, QuoteDocument, QuoteOptions, QuoteArea, OptionsDocument, OrderItem } from 'paintscout'
import type { RenderableSubItem } from '../..'
import type { QuoteItemSection, QuoteItemConsumer, QuoteItemView } from '../../..'
import { getQuoteOptions } from '../../../util/get-options/get-quote-options'
import { getAreaSubstrate } from '../../../area-substrates/get-area-substrate'
import { toRenderableItemSubstrate } from '../../../area-substrates/util'
import type { UpdateableArea } from '../../../areas'
import toRenderableCrewAreaSubstrate from '../get-crew-items-by-area/util/to-renderable-crew-area-substrate'
import toRenderableCrewSubstrateArea from '../get-crew-items-by-substrate/util/to-renderable-crew-substrate-area'
import { formatAreaSubstrate } from './format-area-substrate'

// Correctly format a substrate area based on consumer and view
export const formatSubstrateArea = ({
  areaSubstrate,
  quote,
  areaItem,
  quoteOptions,
  area,
  clientOptions,
  areaSubstrateOrderItem,
  key,
  section,
  showValues,
  consumer,
  view,
  hideDimensions
}: {
  areaSubstrate: AreaSubstrate
  quote: QuoteDocument
  areaItem: UpdateableArea
  quoteOptions: QuoteOptions
  area: QuoteArea
  clientOptions: OptionsDocument
  areaSubstrateOrderItem: OrderItem
  key: string
  section: QuoteItemSection
  showValues: boolean
  consumer?: QuoteItemConsumer
  view?: QuoteItemView
  hideDimensions?: boolean
}): RenderableSubItem => {
  const renderableItemSubstrate = toRenderableItemSubstrate({
    areaSubstrate,
    options: getQuoteOptions({ quote }),
    quote,
    area: areaItem
  })

  if (consumer === 'crew') {
    if (view == 'substrate') {
      const updateableAreaSubstrate = getAreaSubstrate({
        quote,
        options: clientOptions,
        areaKey: key,
        key: areaSubstrateOrderItem.key,
        full: false
      })

      if (!updateableAreaSubstrate) {
        return null
      }

      return toRenderableCrewSubstrateArea({
        key: areaSubstrate.key,
        quote,
        area,
        item: updateableAreaSubstrate,
        showValues,
        quoteOptions,
        options: clientOptions,
        hideDimensions
      })
    } else {
      return toRenderableCrewAreaSubstrate({
        key: areaSubstrate.key,
        quote,
        areaSubstrate: renderableItemSubstrate,
        area,
        showValues,
        options: clientOptions,
        hideDimensions
      })
    }
  } else {
    if (renderableItemSubstrate.inAreaGroup || renderableItemSubstrate.workOrderOnly) {
      return null
    }
    const res = formatAreaSubstrate({
      clientOptions,
      quote,
      key: areaSubstrate.key,
      areaKey: key,
      item: renderableItemSubstrate,
      options: quoteOptions,
      section
    })

    return {
      ...res,
      additionalFields: {
        ...res.additionalFields,
        products: areaSubstrate.product
      }
    }
  }
}
